<template>
  <div style="height: 100%; max-width: 500px" class="mx-auto">
    <div v-if="showTerm || showConsent">
      <Term
        v-if="showTerm"
        @onAgree="
          showTerm = false;
          showConsent = true;
        "
      ></Term>
      <Consent v-if="showConsent" @onAgree="showConsent = false"></Consent>
    </div>
    <div v-else>
      <slot name="header"></slot>
      <v-stepper
        class="elevation-0 pa-0"
        v-model="step"
        style="border-radius: 0px"
      >
        <v-stepper-content class="pa-0" step="1">
          <step-1 @nextstep="step++"></step-1>
        </v-stepper-content>
        <v-stepper-content class="pa-0" step="2">
          <OTP v-if="step == 2" @nextstep="step++"></OTP>
        </v-stepper-content>
        <v-stepper-content class="pa-0" step="3">
          <step-2 v-if="step == 3" @nextstep="step++"></step-2>
        </v-stepper-content>
        <v-stepper-content class="pa-0" step="4">
          <step-3 v-if="step == 4" @nextstep="step++"></step-3>
        </v-stepper-content>
      </v-stepper>
    </div>
  </div>
</template>

<script>
import Term from "./Term.vue";
import Consent from "./Consent.vue";
import Step1 from "./Step1.vue";
import Step2 from "./Step2.vue";
import Step3 from "./Step3.vue";
import OTP from "@/components/OTP.vue";

export default {
  components: {
    Term,
    Consent,
    Step1,
    Step2,
    Step3,
    OTP,
  },
  data() {
    return {
      step: 1,
      showTerm: true,
      showConsent: false,
    };
  },

  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
